import React from 'react';
import classnames from 'classnames';
import {
  Row,
  Col,
  UncontrolledCollapse,
} from 'reactstrap';

import { Intl, Select } from 'components';
import Pagination from '../Pagination';
import TableUI from '../TableUI';

export default React.memo( ( {
  getTableProps, getRowProps, headerGroups, page, pageIndex, prepareRow, gotoPage, canPreviousPage,
  previousPage, canNextPage, nextPage, pageCount, setPageSize, pageSize, filters,
  customToggleFilters, setFilter, isLoading, customFilters, titleContent, rightContent,
  containerClassName, setGlobalFilter, globalFilter, leftPaginationContent,
  pageOptions, setMultipleFilters, tableClassName,
} ) => (
  <div
    className={classnames( containerClassName, {
      'app-component-loading': isLoading,
    } )}
  >
    <Row className="align-items-center">

      {( titleContent || customFilters )
        ? (
          <Col xs={12} md={7} lg={8} className="mb-2 mb-md-0">
            {titleContent}
            {customFilters ? customFilters( {
              filters, setFilter, globalFilter, setGlobalFilter, setMultipleFilters,
            } ) : null}
          </Col>
        ) : null }

      <Col
        xs={12}
        md={( titleContent || customFilters ) ? 5 : 12}
        lg={( titleContent || customFilters ) ? 4 : 12}
      >
        <div className="w-100 d-flex flex-wrap align-items-center justify-content-end">
          <span className="text-sm text-right mr-2">
            <Intl id="itemsPerPage" />
          </span>
          <Select
            name="size"
            size="xsm"
            value={pageSize}
            formGroupClass="m-0 pagination-select"
            options={pageOptions
            || [{ id: 5, name: 5 }, { id: 10, name: 10 }, { id: 20, name: 20 }]}
            onChange={( value ) => {
              gotoPage( 0 );
              setPageSize( value );
            }}
          />
          {!!rightContent
            && (
              <div className="ml-0 ml-sm-2 mt-2 mt-md-0 p-0 d-none d-md-block">
                {rightContent}
              </div>
            )}
          {!!rightContent
            && (
              <div className="ml-0 ml-sm-2 mt-2 mt-md-0 p-0 d-md-none col-12 text-right">
                {rightContent}
              </div>
            )}
        </div>
      </Col>
    </Row>

    {customToggleFilters
      ? (
        <UncontrolledCollapse toggler="#tableToggler">
          <hr className="mt-4 mb-3 border-top" />
          {customToggleFilters( { filters, setFilter, setMultipleFilters } )}
        </UncontrolledCollapse>
      ) : null}


    <div className="py-2">
      <TableUI
        page={page}
        headerGroups={headerGroups}
        prepareRow={prepareRow}
        getTableProps={getTableProps}
        tableClassName={tableClassName}
        getRowProps={getRowProps}
      />
    </div>

    <Pagination
      pageIndex={pageIndex}
      previousPage={previousPage}
      canPreviousPage={canPreviousPage}
      nextPage={nextPage}
      canNextPage={canNextPage}
      pageCount={pageCount}
      leftPaginationContent={leftPaginationContent}
    />
  </div>
) );
